'use client';

import { PropsWithChildren } from 'react';

import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import clsx from 'clsx';

import styles from './ModalSeries.module.scss';

type ModalProps = PropsWithChildren<{
  /*
   * Controls the modal visibility.
   */
  isOpened: boolean;
  /*
   * The callback to handle the modal close.
   */
  onClose?: () => void;
  /*
   * The additional class names for the dialog-content div.
   */
  className?: string;
}>;

export const Modal = ({ children, isOpened, onClose, className }: ModalProps) => {
  return (
    <Dialog.Root open={isOpened} onOpenChange={(open) => !open && onClose?.()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles['dialog-overlay']} />
        <Dialog.Content className={clsx(styles['dialog-content'], className)} aria-describedby={undefined}>
          <Dialog.Title asChild>
            <VisuallyHidden>Series Details</VisuallyHidden>
          </Dialog.Title>
          <div className={styles['dialog-children']}>{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
